export default (open, title, {event='open::grouped-images-modal', ...options}) => ({
    open,
    event,
    title,
    tab: 0,
    key: null,
    currentIndex: null,
    quantity: 1,
    allImages: [],
    groupedImages: null,
    selectedImages: {},
    favoriteImages: [],
    downloading: [],

    init() {
        window.addEventListener(event, ({detail}) => this.set(detail));
        window.addEventListener(`${event}::update::selected`, ({detail}) => this.selectImages(detail));
        window.addEventListener(`close-grouped-images-modal`, () => this.open = false);

        window.addEventListener(`${event}::update`, () => this.refreshVirtualScroll())

        this.$watch('open', (open) => {
            this.$removeScroll(!open);

            if(open) {
                if(/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                    this.$el.querySelector('.images-modal')?.classList.add('ios')
                }
            }
        });
    },

    set({images, selected={}, key=null, quantity=1, currentIndex = null}, open=true, image) {
        this.open = open;
        this.key  = key;
        this.quantity  = quantity;
        this.currentIndex  = currentIndex;
        this.selectedImages = {...selected};

        this.allImages      = Object.values(images);
        this.favoriteImages = this.prepareFavoriteImages(this.allImages);

        this.groupedImages = this.tab == 0
            ? this.allImages
            : this.favoriteImages;

        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.refreshVirtualScroll(image);
    },

    prepareFavoriteImages(allImages) {
        return Object.values(allImages).map(
            (images) => images.filter(
                (image) => image.favorite == 1
            )
        ).filter(element => element.length);
    },

    favoriteTab() {
        this.tab = 1;

        this.groupedImages = this.favoriteImages;
        this.refreshVirtualScroll();
    },

    allTab() {
        this.tab = 0;

        this.groupedImages = this.allImages;
        this.refreshVirtualScroll();
    },

    share() {
        this.$wire.share(this.key);
    },

    openSliderPreview(event) {
        const imageId = _.get(event, 'detail.id');

        const images = this.groupedImages.reduce(
            (items, groupedImages) => [...items, ...groupedImages],
            [],
        );

        this.$dispatch('open::slider-preview', [
            images,
            images.findIndex(image => image.id == imageId),
            {
                canDownload: _.get(options, 'canDownload', false),
                canFavorite: _.get(options, 'canFavorite', false),
                canSelect: _.get(options, 'canSelect', false),
                imageAttr: _.get(options, 'imageAttr', 'preview'),
                watermark: _.get(options, 'watermark'),
                event: `${this.event}::toggle`,
                selected: this.selectedImages,
                quantity: this.quantity,
                totalImagesCount: images.length,
            }
        ]);
    },

    async download(event){
        const image = _.get(event, 'detail');
        const name = _.get(image, 'name');

        if (this.$isMobileSafari()) {
            this.$dispatch('view-photo-modal::open', image);

            this.downloading = this.downloading.filter(
                (downloaded) => downloaded !== name
            );

            this.refreshVirtualScroll(image);

            return;
        }

        this.downloading.push(name);

        this.$downloadImage(_.get(image, 'high_res'), name, () => {
            this.downloading = this.downloading.filter(
                (downloaded) => downloaded !== name
            );

            this.refreshVirtualScroll(image);
        });
    },

    selectImages(images) {
        this.selectedImages = images;
        this.refreshVirtualScroll();
    },

    saved(image) {
        return this.$store.customerImages.isSaved(image.id);
    },

    favorited(image) {
        return this.$store.customerImages.isFavorite(image.id);
    },

    save(event) {
        const image = _.get(event, 'detail', {})

        this.$store.customerImages.toggleImage(image);
        this.favoriteImages = this.prepareFavoriteImages(
            this.$store.customerImages.favorites(true)
        );
    },

    favorite(event) {
        const image = _.get(event, 'detail', {})

        this.$store.customerImages.toggleFavoriteImage(image);
        this.favoriteImages = this.prepareFavoriteImages(
            this.$store.customerImages.favorites(true)
        );
    },

    showPreview({detail}) {
        this.$dispatch('group-tooltip::show', {
            target: detail.target,
            url: detail.data.preview,
            name: detail.data.name,
            document: this.$el
        });
    },

    closePreview() {
        this.$dispatch('group-tooltip::close')
    },

    addToProduct() {
        this.$dispatch('grouped::add-to-product', this.selectedImages);
        this.open = false;
    },

    canSelect() {
        return Object.keys(this.selectedImages).length < this.quantity;
    },

    isSelected(imageId){
        return Object.keys(this.selectedImages)
            .findIndex((id) => String(id) == String(imageId)) > -1;
    },

    length(stored=false) {
        return stored
            ? this.$store.customerImages.length()
            : this.allImages.flat().length;
    },

    handleCheck(event) {
        const image = _.get(event, 'detail.data', {});

        if(this.isSelected(image.id)) {
            delete this.selectedImages[image.id];
            return;
        }

        if( !this.canSelect() ) {
            return;
        }

        if (this.$store.packageData.exceptRequirement(this.currentIndex).hasImage(image.id)) {
            window.$wireui.dialog({
                title: 'DUPLICATE PHOTO WARNING',
                description: `You're trying to add an image you've already selected for other image slots.`,
                icon: "warning",
                closeButton: false,
                close: 'OK, I Understand',
            });
        }

        this.selectedImages[image.id] = image;
    },

    addToProduct() {
        this.$dispatch('grouped::add-to-product', this.selectedImages);
        this.open = false;
    },

    canSelect() {
        return Object.keys(this.selectedImages).length < this.quantity;
    },

    isSelected(imageId){
        return Object.keys(this.selectedImages)
            .findIndex((id) => String(id) == String(imageId)) > -1;
    },

    getLabel({event_name, event_date}) {
        return `(${event_date}) ${event_name}`;
    },

    update() {
        this.$dispatch(`${event}::update`);
    },

    refreshVirtualScroll(image=null, images=null) {
        let data = {images: JSON.parse(JSON.stringify(this.groupedImages))};

        if(image !== null && images !== null) {
            this.set({ images }, this.open, image);
            return;
        }

        if(image !== null) {
            data = { image };
        }

        this.$dispatch(`${event}::refresh`, data);
    }
});
